<template>
  <a-modal
    title=""
    centered
    :width="640"
    :mask-closable="false"
    :visible="showDataForm"
    :confirmLoading="loading"
    :footer="null"
    :bodyStyle="{ paddingTop: '15px' }"
    @cancel="close"
  >
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="提交数据">
        <span v-if="!model.post_data">NULL</span>
        <json-viewer v-else :value="model.post_data" :expand-depth=5 copyable boxed sort />
      </a-tab-pane>
      <a-tab-pane key="2" tab="原始数据">
        <span v-if="!model.original_data">NULL</span>
        <json-viewer v-else :value="model.original_data" :expand-depth=5 copyable boxed sort />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Data';
</style>

<script>
import Data from './Data'
export default Data
</script>
